/* eslint-disable react/prop-types */
import React from 'react'
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import MikeButton from '@mike/mike-shared-frontend/mike-button'
import conversionOptionsTranslations from './translations/conversionOptionsTranslations'
import uploadManyDialogTranslations from './translations/uploadManyDialogTranslations'
import {
  StyledDialogContent,
  StyledDialogActions
} from './styles/datasetUploadStyles'

const StyledConversionOptionsTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(1)
}))

const StyledConversionOptionsSubtitle = styled(Typography)(({ theme }) => ({
  paddingBottom: theme.spacing(3)
}))

const StyledDistance = styled(FormControlLabel)(({ theme }) => ({
  paddingBottom: theme.spacing(1)
}))

const StyledDistanceTop = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(1)
}))

const StyledColorFormControl = styled(FormControl)<{
  component?: React.ElementType
}>(({ theme }) => ({
  color: theme.palette.primary.main,
  '& .MuiTypography-root, .MuiTypography-root.Mui-disabled, .MuiFormControlLabel-root': {
    color: theme.palette.primary.main
  }
}))

export interface ITextResources {
  convertToDifferentFormatOption: string
  asIfOption: string
  submit: string
  title: string
}

interface IProps {
  isZippedFile: boolean
  convert: string
  disableConvert?: boolean
  fileName: string
  handleOnClose: () => void
  handleChange: (event: React.ChangeEvent<unknown>) => void
  handleOnClick: () => void
  textResources?: ITextResources
}

const DatasetConversionOptions = (props: IProps) => {
  const {
    convert,
    disableConvert = false,
    isZippedFile,
    fileName,
    handleOnClose,
    handleChange,
    handleOnClick,
    textResources = {
      submit: conversionOptionsTranslations.upload,
      asIfOption: conversionOptionsTranslations.uploadAsIs,
      title: conversionOptionsTranslations.title,
      convertToDifferentFormatOption:
        conversionOptionsTranslations.convertToDifferentFormat
    }
  } = props
  const [buttonLabel, setButtonLabel] = React.useState(
    conversionOptionsTranslations.upload
  )

  React.useEffect(() => {
    setButtonLabel(
      convert === 'false'
        ? textResources.submit
        : conversionOptionsTranslations.next
    )
  }, [convert, textResources.submit])

  return (
    <>
      <StyledDialogContent>
        <StyledConversionOptionsTitle variant="h4">
          {textResources.title}
        </StyledConversionOptionsTitle>

        <StyledConversionOptionsSubtitle variant="body2">
          {conversionOptionsTranslations.selectedFile + ': ' + fileName}
        </StyledConversionOptionsSubtitle>

        <StyledColorFormControl component="fieldset">
          <RadioGroup
            aria-label="option"
            name="option1"
            value={convert}
            onChange={handleChange}
          >
            <StyledDistance
              value="false"
              control={<Radio color="primary" />}
              label={textResources.asIfOption}
            />
            <FormControlLabel
              disabled={disableConvert}
              value="true"
              control={<Radio color="primary" />}
              label={textResources.convertToDifferentFormatOption}
            />
          </RadioGroup>
        </StyledColorFormControl>
        {isZippedFile && (
          <StyledDistanceTop variant="body2">
            {uploadManyDialogTranslations.additionalMessageForZippedFiles}
          </StyledDistanceTop>
        )}
      </StyledDialogContent>
      <StyledDialogActions>
        <MikeButton onClick={handleOnClose} buttontype="text">
          {conversionOptionsTranslations.cancel}
        </MikeButton>
        <MikeButton onClick={handleOnClick} buttontype="primary">
          {buttonLabel}
        </MikeButton>
      </StyledDialogActions>
    </>
  )
}

export default DatasetConversionOptions
